const UNITS = [
    { label: 'year', seconds: 365 * 24 * 60 * 60 },
    { label: 'month', seconds: 30 * 24 * 60 * 60 },
    { label: 'week', seconds: 7 * 24 * 60 * 60 },
    { label: 'day', seconds: 24 * 60 * 60 },
    { label: 'hour', seconds: 60 * 60 },
    { label: 'minute', seconds: 60 },
];

const pluralize = (value: number, label: string) => `${value} ${label}${value === 1 ? '' : 's'} ago`;

export const formatRelativeTime = (dateValue?: string) => {
    if (!dateValue) {
        return '';
    }

    const timestamp = new Date(dateValue).getTime();
    if (Number.isNaN(timestamp)) {
        return '';
    }

    const secondsAgo = Math.max(0, Math.floor((Date.now() - timestamp) / 1000));
    if (secondsAgo < 60) {
        return 'just now';
    }

    const unit = UNITS.find((item) => secondsAgo >= item.seconds);
    if (!unit) {
        return 'just now';
    }

    return pluralize(Math.floor(secondsAgo / unit.seconds), unit.label);
};
